var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "eid-preview-wrap" },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.spinning } },
        [
          _c("pageTitle", { attrs: { pageTitle: "没有找到我的设备提示" } }),
          _c("div", { staticClass: "page-main" }, [
            _c("div", { staticClass: "video-title" }, [
              _c(
                "p",
                {
                  staticClass: "title mt25",
                  staticStyle: { display: "block" },
                },
                [_vm._v("实时预览")]
              ),
              _c("div", { staticClass: "eid-preview" }, [
                _c("div", { staticClass: "preview" }, [
                  _c("div", { staticClass: "preview-header" }),
                  _c("div", {
                    staticClass: "content-html",
                    domProps: { innerHTML: _vm._s(_vm.content) },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "eid" },
                  [
                    _vm.show
                      ? _c("edit-components", {
                          attrs: {
                            uploadImg: _vm.uploadImg,
                            "upload-path": _vm.uploadPath,
                            content: _vm.content,
                            "html-change": _vm.htmlChange,
                          },
                        })
                      : _vm._e(),
                    _c(
                      "a-button",
                      {
                        staticClass: "saveBtn",
                        attrs: { type: "primary", disabled: !_vm.isSave },
                        on: { click: _vm.save },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }